import { RESET, SET } from './constants';

export const resetPromoCode = () => ({
  type: RESET,
});

export const setPromoCode = promoCode => ({
  type: SET,
  payload: promoCode,
});
